<template>
  <div class="board" >
	  <div class="setting-container">
		  <el-radio-group class="type-radio-group" v-model="dateType" size="mini" @change="changeDateType">
			<el-radio-button label="1">今日</el-radio-button>
			<el-radio-button label="2">本月</el-radio-button>
			<el-radio-button label="">全部</el-radio-button>
		  </el-radio-group>
		  <el-date-picker
			v-model="timeRange"
			@change="getdata"
			size="mini"
			type="daterange"
			range-separator="至"
			start-placeholder="开始日期"
			end-placeholder="结束日期">
		  </el-date-picker>
	  </div>
	  <div class="stastic-line" >
		  <el-row type="flex" justify="space-between" style="border-bottom: 8px solid #DCDFE6;padding-bottom: 16px;">
			  <el-col :span="4">
				  <h5>{{info.zc}}</h5>
				  <p>注册 
					  <el-tooltip class="item" effect="dark" content="自然或邀请注册的用户人数" placement="bottom">
				        <el-image class="icon-img" src="https://webcc-pro.obs.cn-east-3.myhuaweicloud.com:443/imge/info.png"></el-image>
				      </el-tooltip>
				  </p>
			  </el-col>
			  <el-col :span="4">
				  <h5>{{info.sjb}}</h5>
				  <p>设计版 
					  <el-tooltip class="item" effect="dark" content="直接开通设计版账号或升级为设计版的用户数" placement="bottom">
						<el-image class="icon-img" src="https://webcc-pro.obs.cn-east-3.myhuaweicloud.com:443/imge/info.png"></el-image>
					  </el-tooltip>
				  </p>
			  </el-col>
			  <el-col :span="4">
				  <h5>{{info.slb}}</h5>
				  <p>算料版 
					  <el-tooltip class="item" effect="dark" content="直接开通设计版账号或升级为算料版的用户数" placement="bottom">
						<el-image class="icon-img" src="https://webcc-pro.obs.cn-east-3.myhuaweicloud.com:443/imge/info.png"></el-image>
					  </el-tooltip>
				  </p>
			  </el-col>
			  <el-col :span="4">
				  <h5>{{info.gjb}}</h5>
				  <p>高级版 
					  <el-tooltip class="item" effect="dark" content="直接开通设计版账号或升级为高级版的用户数" placement="bottom">
						<el-image class="icon-img" src="https://webcc-pro.obs.cn-east-3.myhuaweicloud.com:443/imge/info.png"></el-image>
					  </el-tooltip>
				  </p>
			  </el-col>
			  <el-col :span="4">
				  <h5>{{info.dl}}</h5>
				  <p>登录 
					  <el-tooltip class="item" effect="dark" content="登录的用户数" placement="bottom">
						<el-image class="icon-img" src="https://webcc-pro.obs.cn-east-3.myhuaweicloud.com:443/imge/info.png"></el-image>
					  </el-tooltip>
				  </p>
			  </el-col>
		  </el-row>
		  
		  <el-row type="flex" >
			  <el-col :span="4">
				  <h5>{{info.ljzc}}</h5>
				  <p>累计注册 
					  <el-tooltip class="item" effect="dark" content="自然或邀请注册的用户总人数" placement="bottom">
						<el-image class="icon-img" src="https://webcc-pro.obs.cn-east-3.myhuaweicloud.com:443/imge/info.png"></el-image>
					  </el-tooltip>
				  </p>
			  </el-col>
			  <el-col :span="6">
				  <h5>{{info.ljgm}}</h5>
				  <p>累计购买 
					  <el-tooltip class="item" effect="dark" content="开通设计版或算料版的总用户数" placement="bottom">
						<el-image class="icon-img" src="https://webcc-pro.obs.cn-east-3.myhuaweicloud.com:443/imge/info.png"></el-image>
					  </el-tooltip>
				  </p>
			  </el-col>
			  <el-col :span="4">
				  <h5>{{info.dqlc}}</h5>
				  <p>当前留存 
					  <el-tooltip class="item" effect="dark" content="当前还在使用的总用户数" placement="bottom">
						<el-image class="icon-img" src="https://webcc-pro.obs.cn-east-3.myhuaweicloud.com:443/imge/info.png"></el-image>
					  </el-tooltip>
				  </p>
			  </el-col>
		  </el-row>
	  </div>
	<el-row :gutter="20" class="chart-row">
	  <el-col :span="12">
		  <div>
			  <h6>注册走势</h6>
		  </div>
		  <div id="chart" class="chart" style="height: 300px;"></div>
	  </el-col>
	  <el-col :span="12">
		  <div>
			  <h6>付费走势</h6>
		  </div>
		  <div id="chart2" class="chart" style="height: 300px;"></div>
	  </el-col>
	  <el-col :span="12">
		  <div>
			  <h6>活跃走势</h6>
		  </div>
		  <div id="chart3" class="chart" style="height: 300px;"></div>
	  </el-col>
	  <el-col :span="12">
		  <div>
			  <h6>流失走势</h6>
		  </div>
		  <div id="chart4" class="chart" style="height: 300px;"></div>
	  </el-col>
	</el-row>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  data: () => ({
	timeRange: [],
	dateType: '1',
    obj: null,
    byday: true,
    datelist: [],
    monlist: [],
    timer: null,
	info: {}
  }),
  methods: {
    getdata() {
		var params = {
			start_time: this.timeRange[0] ? moment(this.timeRange[0]).format('YYYY-MM-DD') : "",
			end_time: this.timeRange[1] ? moment(this.timeRange[1]).format('YYYY-MM-DD') : ''
		}
      this.$axios.get("operation/account-data",params).then(res => {
        if (res.code == 1) {
			this.info = {
				zc: res.data.today_register_times,
				sjb: res.data.today_sjb,
				slb: res.data.today_slb,
				gjb: res.data.today_gjb,
				dl: res.data.today_login_times,
				ljzc: res.data.total_register_times,
				ljgm: res.data.total_purchase_times,
				dqlc: res.data.total_current_using_number
			}
			let chartData = res.data.line_register_purchase_day
			this.datelist = chartData.date_list
			this.initChart('chart',chartData.register_list.data)
			this.initChart('chart2',chartData.purchase_list.data)
			this.initChart('chart3',chartData.login_list.data)
			this.initChart('chart4',chartData.lost_list.data)
          // this.$set(this, "obj", res.data);
          // this.$set(
          //   this,
          //   "datelist",
          //   res.data.line_register_purchase_day.date_list
          // );
          // this.$set(this, "monlist", res.data.line_month.date_list);
          // setTimeout(() => {
            // this.drawzhexian();
            // this.zhexian2();
          // }, 10);
        }
      });
    },
	initChart(container,data) {
		let option = {
		  xAxis: {
		    type: 'category',
		    data: this.datelist
		  },
		  yAxis: {
		    type: 'value'
		  },
		  series: [
		    {
		      data: data,
		      type: 'line',
		      smooth: true,
			  lineStyle: {
				  normal: {
					  color: 'rgb(31,111,233)'
				  }
			  },
			  itemStyle: {
				  normal: {
					  // opacity: 0,
					  color: 'rgb(31,111,233)'
				  }
			  }
		    }
		  ],
		  grid: {
		    right: "0",
		    bottom: "2%",
		    left: "0",
		    top: "8%",
		    containLabel: true
		  },
		  tooltip: {
			  formatter: '{b0}: {c0}'
		  }
		};
		this[container].setOption(option);
	},
	initAll() {
		let containers = document.querySelectorAll('.chart')
		containers.forEach((ele) =>{
			this.initChart(ele.id)
		})
	},
	changeDateType(n) {
		var now = new Date()
		if(n == '1') {
			this.timeRange = [now,now]
		}else if(n == '2') {
			var start = new Date()
			    start.setTime(start.getTime() - 3600 * 1000 * 24 * (now.getDate() - 1));
			this.timeRange = [start,now]
		}else{
			this.timeRange = []
		}
		this.getdata()
	},
    drawzhexian() {
      let zhexian = this.$echarts.init(document.getElementById("zhexian"));
      zhexian.setOption({
        // backgroundColor: "#00253f",
        color: [
          "#FFAD05",
          "#1C805B",
          "#F07339",
          "#EAEA26",
          "#906BF9",
          "#FE5656",
          "#01E17E",
          "#3DD1F9"
        ],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross"
          }
        },
        legend: {
          x: "center",
          y: "40px",
          textStyle: {
            color: "#000",
            fontSize: 13
          },
          icon: "circle"
        },
        dataZoom: [
          {
            type: "slider",
            show: true,
            height: 20,
            left: "10%",
            right: "10%",
            bottom: "2%",
            start: 50,
            end: 100,
            textStyle: {
              color: "#d4ffff",
              fontSize: 11
            }
          },
          {
            type: "inside"
          }
        ],
        grid: {
          right: "5%",
          bottom: "10%",
          left: "2%",
          top: "80px",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            data: this.byday ? this.datelist : this.monlist,
            name: "时间",
            nameTextStyle: {
              color: "#000"
            },
            axisLine: {
              lineStyle: {
                color: "#000"
              }
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: "#000",
                fontSize: 12
              }
            }
          }
        ],
        yAxis: [
          {
            type: "value",
            nameTextStyle: {
              color: "#000"
            },
            position: "left",
            axisLine: {
              lineStyle: {
                color: "#0B4CA9"
              }
            },
            splitLine: {
              lineStyle: {
                color: "#0B4CA9"
              }
            },
            axisLabel: {
              color: "#000",
              fontSize: 12
            }
          }
        ],
        series: this.formdata()
      });
    },
    zhexian2() {
      let zhexian2 = this.$echarts.init(document.getElementById("zhexian2"));
      zhexian2.setOption({
        color: [
          "#906BF9",
          "#FE5656",
          "#FFAD05",
          "#1C805B",
          "#F07339",
          "#EAEA26",
          "#01E17E",
          "#3DD1F9"
        ],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross"
          }
        },
        legend: {
          x: "center",
          y: "40px",
          textStyle: {
            color: "#000",
            fontSize: 13
          },
          icon: "circle"
        },
        dataZoom: [
          {
            type: "slider",
            show: true,
            height: 20,
            left: "10%",
            right: "10%",
            bottom: "2%",
            start: 50,
            end: 100,
            textStyle: {
              color: "#d4ffff",
              fontSize: 11
            }
          },
          {
            type: "inside"
          }
        ],
        xAxis: [
          {
            type: "category",
            data: this.monlist,
            name: "时间",
            nameTextStyle: {
              color: "#000"
            },
            axisLine: {
              lineStyle: {
                color: "#000"
              }
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: "#000",
                fontSize: 12
              }
            }
          }
        ],
        yAxis: [
          {
            type: "value",
            nameTextStyle: {
              color: "#000"
            },
            position: "left",
            axisLine: {
              lineStyle: {
                color: "#0B4CA9"
              }
            },
            splitLine: {
              lineStyle: {
                color: "#0B4CA9"
              }
            },
            axisLabel: {
              color: "#000",
              fontSize: 12
            }
          }
        ],
        series: this.formdata1()
      });
    },
    formdata() {
      var list = [];
      if (this.byday) {
        var obj1 = this.doform(
          this.obj.line_register_purchase_day.register_list
        );
        var obj2 = this.doform(
          this.obj.line_register_purchase_day.purchase_list
        );
        list.push(obj1);
        list.push(obj2);
        return list;
      } else {
        var obj1 = this.doform(this.obj.line_month.register_list);
        var obj2 = this.doform(this.obj.line_month.purchase_list);

        list.push(obj1);
        list.push(obj2);
        return list;
      }
    },
    formdata1() {
      var list = [];
      var obj1 = this.doform(this.obj.line_month.purchase_ratio_list);
      var obj2 = this.doform(this.obj.line_month.current_using_ratio_list);
      list.push(obj1);
      list.push(obj2);
      return list;
    },
    doform(val) {
      var obj = val;
      this.$set(obj, "type", "line");
      this.$set(obj, "yAxisIndex", "0");
      this.$set(obj, "symbolSize");
      return obj;
    }
  },
  mounted() {
	  this.chart = this.$echarts.init(document.querySelector('#chart'));
	  this.chart2 = this.$echarts.init(document.querySelector('#chart2'));
	  this.chart3 = this.$echarts.init(document.querySelector('#chart3'));
	  this.chart4 = this.$echarts.init(document.querySelector('#chart4'));
	  var now = new Date()
	this.timeRange = [now,now]
    this.getdata();
    // this.timer = setInterval(() => {
    //   this.getdata();
    // }, 5000);
  },
  beforeDestroy() {
    // clearInterval(this.timer); // 清除定时器
    // this.timer = null;
  }
};
</script>

<style lang="scss" scoped>
.board {
  .top {
    .content {
      background: #c5eafc;
      margin: 5px;
      .el-col {
        text-align: center;
      }
    }
  }
  .middle {
    .content {
      background: #c5eafc;
      margin: 5px;
      div {
        text-align: center;
      }
    }
    #zhexian {
      height: 300px;
    }
  }
  .bottom {
    #zhexian2 {
      height: 400px;
      margin-bottom: 100px;
    }
  }
}
.chart{
	// height: 300px;
}
.type-radio-group{
	margin: 10px 0;
	.el-radio-button{
		margin-right: 12px;
		/deep/ .el-radio-button__inner{
			border-left: 1px solid #DCDFE6;
			border-radius: 4px;
		}
		/deep/ .el-radio-button__orig-radio:checked+.el-radio-button__inner{
			border-left: 1px solid #409EFF;
		}
	}
}
.stastic-line{
	padding-bottom: 20px;
	border-bottom: 8px solid #DCDFE6;
	.el-col{
		text-align: center;
		h5{
			font-size: 24px;
			margin: 24px 0 2px;
		}
		p{
			font-size: 14px;
			color: rgb(102,102,102);
		}
		.icon-img{
			width: 12px;
			height: 12px;
			margin-left: 6px;
		}
	}
	
}
.chart-row{
	.el-col{
		border-bottom: 8px solid #DCDFE6;
	}
	.el-col:nth-of-type(odd){
		border-right: 8px solid #DCDFE6;
	}
	h6{
		font-size: 16px;
		margin: 12px 0 0;
		padding-left: 12px;
	}
}
</style>